module.exports = __webpack_public_path__ + "f8103e25809aac91c8a55f5282820c4f.svg";